module.exports = __webpack_public_path__ + "img/home-notice.3c9d887f.png";